import { render, staticRenderFns } from "./SocialColumn.vue?vue&type=template&id=1946b1b6&"
import script from "./SocialColumn.vue?vue&type=script&lang=js&"
export * from "./SocialColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports